import SiteRoutes from './SiteRoutes';
import SiteRoutesContainer from './SiteRoutesContainer';

export default SiteRoutesContainer;
export { SiteRoutes };
